const routes = [{
    icon: "",
    path: '/cadastro-de-tarefas',
    name: 'CadastroTarefas',
    component: () => import('@/views/CadastroTarefas'),
    title: 'Cadastro de tarefas',
    meta:{
      tarefasRequired: true,
      pessoaLogadaRequired: true
    },
    
  },
  {
    icon: "",
    path: '/minhas-tarefas',
    name: 'Minhas tarefas',
    component: () => import('@/views/Dashboard'),
    meta:{
      tarefasRequired: true,
      pessoaLogadaRequired: true
    }
  },
  {
    icon: "",
    path: '/grupo-de-tarefas',
    name: 'Grupo de tarefas',
    component: () => import('../views/GrupoDeTarefas'),
    title: 'Grupo de tarefas',
    meta:{
      tarefasRequired: true,
      pessoaLogadaRequired: true
    }
  },
  {
    icon: "",
    path: '/cadastro-de-modelos',
    name: 'Cadastro de modelos',
    component: () => import('../views/CadastroDeModelos'),
    title: 'Cadastro de modelos',
    meta:{
      tarefasRequired: true,
      pessoaLogadaRequired: true
    }
  },
  {
    icon: "",
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/DashboardGestor'),
    title: 'Dashboard',
    meta:{
      tarefasRequired: true,
      pessoaLogadaRequired: true
    }
  },
  {
    icon: "",
    path: '/elegalize',
    name: 'eLegalize',
    component: () => import('../views/Legalize'),
    title: 'eLegalize',
    meta:{
      pilotoTarefasRequired: false,
      tarefasRequired: true,
      pessoaLogadaRequired: true
    }
  },
  {
    icon: "",
    path: '/elegalize/form',
    name: 'eLegalizeForm',
    component: () => import('../views/Legalize/Formulario'),
    title: 'eLegalize Form',
    meta:{
      openRoute: true,
      tarefasRequired: false,
      pessoaLogadaRequired: false,
      pilotoTarefasRequired: false
    },
    beforeEnter: (to, from) => {
      const queryKeys = Object.keys(to.query);
      if (queryKeys.length != 1 || !queryKeys.includes("key") || !to.query["key"]) {
        return false
      }
    }
  },
  {
    icon: "",
    path: '/elegalize/progresso',
    name: 'eLegalizeFormProgresso',
    component: () => import('../views/Legalize/Progresso'),
    title: 'eLegalize Form Progresso',
    meta:{
      openRoute: true,
      tarefasRequired: false,
      pessoaLogadaRequired: false,
      pilotoTarefasRequired: false
    },
    beforeEnter: (to, from) => {
      const queryKeys = Object.keys(to.query);
      if (queryKeys.length != 1 || !queryKeys.includes("key") || !to.query["key"]) {
        return false
      }
    }
  },
  {
    icon: "",
    path: '/elegalize/form/salvo',
    name: 'eLegalizeFormAConcluir',
    component: () => import('../views/Legalize/Formulario/AConcluir'),
    title: 'eLegalizeFormAConcluir',
    meta:{
      openRoute: true,
      tarefasRequired: false,
      pessoaLogadaRequired: false,
      pilotoTarefasRequired: false
    }
  },
  {
    icon: "",
    path: '/elegalize/form/enviado',
    name: 'eLegalizeFormSucesso',
    component: () => import('../views/Legalize/Formulario/SucessoCliente'),
    title: 'eLegalize Formulário Cadastrado com sucesso!',
    meta:{
      openRoute: true,
      tarefasRequired: false,
      pessoaLogadaRequired: false,
      pilotoTarefasRequired: false
    }
  },
  {
    icon: "",
    path: '/elegalize/form/visualizar/:id',
    name: 'eLegalizeVisualizarFormulário',
    component: () => import('../views/Legalize/Formulario'),
    title: 'eLegalize Visualizar Formulário',
    meta:{
      pilotoTarefasRequired: false,
      pessoaLogadaRequired: true,
      tarefasRequired: true
    }
  },
  {
    icon: "",
    path: '/urlanexo',
    name: 'UrlAnexo',
    component: () => import('../views/UrlAnexo'),
    title: 'UrlAnexo',
    meta:{
      tarefasRequired: true,
      pessoaLogadaRequired: true,
    }
  },
  {
    icon: "",
    path: '/manutencao',
    name: 'Manutencao',
    component: () => import('@/views/Manutencao'),
    title: 'Manutencao',
    meta:{
      openRoute: true,
      tarefasRequired: false,
      pilotoTarefasRequired: false,
      pessoaLogadaRequired: false,
    }
  },
  {
    icon: "",
    path: '/formularios',
    name: 'Formulario',
    component: () => import('../views/Formulario'),
    title: 'Cadastro de formulários',
    meta:{
      pilotoTarefasRequired: false,
      tarefasRequired: true,
      pessoaLogadaRequired: true,
    },
  },
  {
    icon: "",
    path: '/formularios/visualizar/:id',
    name: 'VisualizarFormulario',
    component: () => import('../views/Formulario/Visualizar'),
    title: 'Visualizar formulário',
    meta:{
      pilotoTarefasRequired: false,
      tarefasRequired: true,
      pessoaLogadaRequired: true,
    }
  },
  {
    icon: "",
    path: '/formularios/novo',
    name: 'NovoFormulario',
    component: () => import('../views/Formulario/Novo'),
    title: 'Novo Formulário',
    meta:{
      pilotoTarefasRequired: false,
      pessoaLogadaRequired: true,
      tarefasRequired: true
    }
  },
  {
    icon: "",
    path: '/formularios/edicao/:id',
    name: 'EdicaoFormulário',
    component: () => import('../views/Formulario/Novo'),
    title: 'Editar Formulário',
    meta:{
      pilotoTarefasRequired: false,
      pessoaLogadaRequired: true,
      tarefasRequired: true
    }
  },
  {
    icon: "",
    path: '/formularios/responder',
    name: 'FormularioTarefaResponder',
    component: () => import('../views/Formulario/Responder'),
    title: 'Responder Formulário',
    meta: {
      openRoute: true,
      tarefasRequired: false,
      pessoaLogadaRequired: false,
      pilotoTarefasRequired: false
    },
    beforeEnter: (to, from) => {
      const queryKeys = Object.keys(to.query);
      if (queryKeys.length != 1 || !queryKeys.includes("key") || !to.query["key"]) {
        return false
      }
    }
  },
  {
    icon: "",
    path: '/formularios/responder/salvo',
    name: 'FormularioTarefaAConcluir',
    component: () => import('../views/Formulario/Responder/AConcluir'),
    title: 'Formulário Salvo',
    meta: {
      openRoute: true,
      tarefasRequired: false,
      pessoaLogadaRequired: false,
      pilotoTarefasRequired: false
    }
  },
  {
    icon: "",
    path: '/formularios/responder/enviado',
    name: 'FormularioTarefaSucesso',
    component: () => import('../views/Formulario/Responder/SucessoCliente'),
    title: 'Formulário Enviado',
    meta: {
      openRoute: true,
      tarefasRequired: false,
      pessoaLogadaRequired: false,
      pilotoTarefasRequired: false
    }
  },
  {
    icon: "",
    path: '/formularios/visualizar/:id',
    name: 'FormularioTarefaVisualizar',
    component: () => import('../views/Formulario/Responder'),
    title: 'Visualizar Formulário',
    meta: {
      pilotoTarefasRequired: false,
      pessoaLogadaRequired: true,
      tarefasRequired: true
    }
  },
  {
    icon: "",
    path: '/tarefas-cliente',
    name: 'TarefasCliente',
    component: () => import('../views/TarefasCliente/TarefasCliente.vue'),
    title: 'Tarefas do Cliente',
    meta:{
      pilotoTarefasRequired: true,
      tarefasRequired: true,
      pessoaLogadaRequired: true
    }
  },
]

export default routes;
